// extracted by mini-css-extract-plugin
module.exports = {"main":"_2SAbk","area":"_9R8p0","card":"_176OP _2s-6N","cardOrganicPaid":"_IzEi","cardReactions":"_1EBV4","cardTotals":"_3C_mv","summaryList":"_3S92H"};